export default "__VITE_ASSET___neDbbbq__"